<template>
  <div class="discover">
    <templet-factory v-for="(block, key) in blocks" :key="key" 
      :template="block.template" 
      :isShowTitle="true" 
      :list="block.list" 
      :dataTitle="block.title" 
      :dataId="parseInt(block.id)" 
      :clickMore="clickMore"
      :hasMore="parseInt(block.hasmore)" />
    <!-- <router-link to="/my"><img class="keep" src="@/assets/cat.png"></router-link> -->
    <div v-show="networkError" class="network-error">
      <div><img src="@/assets/network_error.png"></div>
      <div class="desc">网络出了一点小差~</div>
      <div class="try">请刷新试试~</div>
      <button @click="init">刷新</button>
    </div>
  </div>
</template>

<script>
// import { Loadmore } from 'mint-ui'
import TempletFactory from '@/components/TempletFactory'
import { openWindow } from '@/api/app'
import { umtrack } from '@/utils/uweb'
import { getViewInfo } from '@/api/discover'
export default {
  name: 'discover',
  components: {
    // Loadmore,
    TempletFactory
  },
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  created () {
    umtrack('mainView', {target: '/'}, this)
    this.init();
  },
  data () {
    return {
      topStatus: '',
      blocks: [],
      networkError: false
    }
  },
  methods: {
    init: function () {
      this.networkError = false
      return getViewInfo().then(response => {
        this.blocks = response.data.data
        return new Promise(function (resolve, reject) {
          resolve(true)
        })
      }).catch(()=>{
        this.networkError = true
      })
    },
    loadTop: function () {
      this.init().then(()=>{
        this.$refs.loadmore.onTopLoaded()
      })
    },
    clickMore: function (id, title) {
      for (var block of this.blocks) {
        if (block.id != id) {
          continue
        }
        if (block.redirect) {
          if (block.urltype == 0) {
            openWindow(1, block.redirect, '', this)
          } else {
            openWindow(0, block.redirect, '', this)
          }
          return
        }
        openWindow(0, '/more', {id: id, template: block.template, title: title}, this)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@keyframes Restless-heart {
  0% {
    transform: translate(0px, 0px);
  }
  50% {
    transform: translate(0px, -20px);
  }
  100% {
    transform: translate(0px, 0px);
  }
}
.discover{
  min-height: 100vh;
  background-color: #fff;
  .mint-loadmore{
    min-height: 100vh;
  }
  .keep{
    position: fixed;
    bottom: 96px;
    right: 16px;
    width: 37px;
    height: 37px;
    border-radius: 16px;
    animation: Restless-heart 1s infinite;
  }
  .network-error{
    .desc{
      margin: 10px 0;
    }
    .try{
      color: #999;
      font-size: 14px;
    }
    button{
      outline: none;
      border: none;
      background:linear-gradient(315deg,rgba(78,151,255,1) 0%,rgba(56,190,237,1) 100%);
      border-radius:8px;
      color: #fff;
      padding: 10px 64px;
      margin-top: 22px;
    }
  }
}
</style>